import React, { lazy } from "react"
import _ from "underscore";
import bindActionCreators from "redux/src/bindActionCreators";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import config from "./config";
import HeaderMenuItem from "./components/Header/HeaderMenuItem";
import SearchBar from "./components/Header/search-bar/SearchBar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Headroom from "react-headroom";
import {
    closeShopifyCart,
    openShopifyCart
} from "./components/actionCreators/shopifyAC";
import {
    closeLoginModal,
    userLoggedIn,
    userLoggedOut,
    showModalSpinner,
    hideModalSpinner,
    signupSuccess,
    getPromoBanners,
    getVaultItems,
    getForYouHomepageData,
    socialError,
    renderLogoutPopup,
    dismissLogoutPopup,
    logout,
    noScroll,
} from "./components/actionCreators/appAC";
import {getRecentlyViewed, renderAuthPopup} from "./components/actionCreators/pdpAC";
import Image from "react-bootstrap/Image";
import NavbarBrand from "react-bootstrap/esm/NavbarBrand";
import Button from "react-bootstrap/Button";
import { getSavedSearches } from "./components/actionCreators/myAccountAC"
import OfferCodeThankYouModal from "./components/OfferCoupon/OfferCodeThankYouModal";
import Currency from "./components/common/Currency";
import {
    addNoScroll,
    canSeeFirstLook, checkSubscriptionStatus,
    getCookie, isTYPage,
    isRPlusMembershipActive,
    removeNoScroll,
    setIntercomUserDetails,
} from "./components/common/utils";
import FirstLookNav from "./components/Header/common/FirstLookNav";
import {
    BarcodeIcon,
    BoxIcon,
    ChecklistIcon, LogOutIcon,
    ProfileIcon,
    WalletIcon,
    LabelIcon,
    RewardsPlusLogo,
    ArrowDownRounded,
    SearchIconThin,
    HeartIcon,
    BookmarkIcon,
    CartIcon,
} from "./components/common/Icons";
import { setSavedSearchesModal } from "./components/actionCreators/boostCommerceAC"
import SaveSearchModal from "./components/PLP/SaveSearchModal"
import { showVipModal } from "./components/actionCreators/favoritesAC"
import InProductMKTPopup from "./components/common/InProductMKTPopup"
import HeaderSimplified from "./components/cart/HeaderSimplified";
import { filterForYouMenuItemForNoLoggedInUser } from "./components/Header/helpers"

const TopCarouselPromo = lazy(() => import("./components/Header/TopCarouselPromo" /* webpackChunkName: "TopCarouselPromo" */));
const SidebarMenu = lazy(() => import("./components/Header/SidebarMenu" /* webpackChunkName: "SidebarMenu" */));
const LoginModal = lazy(() => import("./components/Login/LoginModal" /* webpackChunkName: "LoginModal" */));
const ConfirmEmail = lazy(() => import("./components/ConfirmEmail" /* webpackChunkName: "ConfirmEmail" */));
const VipModal = lazy(() => import("./components/PDP/Columns/Modals/VipModal" /* webpackChunkName: "VipModal" */));
const FinishSignupModal = lazy(() => import("./components/Login/FinishSignupModal" /* webpackChunkName: "LoginModal" */));

const initial_menus_state = {
    show_bags_menu: false,
    show_designers_menu: false,
    show_magazine_menu: false,
    show_stores_menu: false
};

class Header extends React.Component {
    constructor(props) {
        super(props);

        const init = {
            user: getCookie('auth_token') || null,
            mobileSearch: false,
            sidebarOpen: false,
            headerVisible: true,
            headerHeight: 0,
            isCheckoutPage: props.isCheckoutPage,
            isIndexPage: false,
            show_cart: false,
            checkout: null,
            login_modal: null,
            display_message_evt: null,
            login_type: "signup",
            success_signup: false,
            suppress_newsletter_modal: false,
            login_newsletter: false,
            signup_msg: "",
            error_msg: "",
            login_type_was_changed: false,
            last_changed: null,
            profile_toggle_status: false
        };

        this.state = _.assign({}, initial_menus_state, init);
        this.burgerButtonRef = React.createRef();
        this.showHideMenus = this.showHideMenus.bind(this);
        this.reactAuthVisual = this.reactAuthVisual.bind(this);
        this.reactLoginError = this.reactLoginError.bind(this);
        this.openLoginModal = this.openLoginModal.bind(this);
        this.openLogoutModal = this.openLogoutModal.bind(this);
        this.toggleMobileSearch = this.toggleMobileSearch.bind(this);
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
        this.headerVisibility = this.headerVisibility.bind(this);
        this.dismissCart = this.dismissCart.bind(this);
        this.handleLoginType = this.handleLoginType.bind(this);
        this.resetLogin = this.resetLogin.bind(this);
        this.goBack = this.goBack.bind(this);
        this.closeMobileSearch = this.closeMobileSearch.bind(this);
        this.focusMainContent = this.focusMainContent.bind(this);
        this.handleLoginTypeURLParameterChange = this.handleLoginTypeURLParameterChange.bind(this);
        this.toggleProfile = this.toggleProfile.bind(this);

        window.rebagHeader = this;
    }

    componentDidMount() {
        const {isCheckoutPage} = this.state;
        const {mobile_big} = this.props;
        const history = this.props.history;
        const url_params = new URLSearchParams(window.location.search);

        this.props.getPromoBanners();
        this.props.getVaultItems();

        if (window.location.href === config.host_rebag) {
            this.setState({isIndexPage: true});
        }

        if (mobile_big && !isCheckoutPage) {
            this.burgerButtonRef.current.focus();
            this.burgerButtonRef.current.blur();
        }

        if (url_params.has("next")) {
            const next_param = url_params.get("next");
            setTimeout(() => {
                if(next_param.search('trade-in') !== -1){
                    this.renderAuthPopup('signup', null, 'To get an offer for an item item you want to trade-in please sign-up' );
                } else {
                    this.renderAuthPopup('login' );
                }
            }, 1000)
        }
    }


    componentWillReceiveProps(next_props) {
        this.setState({
            signup_msg: next_props.signup_msg,
            success_signup: next_props.success_signup,
            suppress_newsletter_modal: next_props.suppress_newsletter_modal,
            login_type: this.state.login_type_was_changed ? this.state.login_type : (this.state.login_type !== "login" ? next_props.login_type : "login")
        })
    }

    toggleProfile(profile_toggle_status) {
        this.setState({
            profile_toggle_status: profile_toggle_status
        });
    }

    onSetSidebarOpen(open) {
        this.setState({sidebarOpen: open});
        if(open) {
            this.props.noScroll(true);
        }
        else {
            this.props.noScroll(false);
            this.burgerButtonRef.current.focus();
            this.burgerButtonRef.current.blur();
        }
    }

    showHideMenus(action) {
        const next_menus_state = _.assign({}, initial_menus_state, action);
        this.setState(next_menus_state);
    }

    reactLoginError = (error) => {
        this.setState({
            error_msg: error
        }, this.props.hideModalSpinner())
    }

    renderAuthPopup(login, callback, msg) {
        this.openLoginModal(login, callback, msg);
    }

    reactAuthVisual(userObj, isSocialLogin) {
        const {login_type} = this.state;
        const {userLoggedIn, userLoggedOut, closeLoginModal, signupSuccess, hideModalSpinner} = this.props;
        this.resetLogin();
        if (userObj) {
            userLoggedIn(isSocialLogin);
            if (login_type === null || login_type === "login") {
                closeLoginModal();
            } else {
                signupSuccess(true);
            }
            hideModalSpinner();
            setIntercomUserDetails(userObj);
        } else {
            userLoggedOut();
            closeLoginModal();
            if (typeof window.Intercom === "function") {
                window.Intercom('shutdown');
            }
        }
    }

    toggleMobileSearch() {
        if (this.state.mobileSearch){
            this.props.noScroll(true);
        }
        this.setState({
            mobileSearch: !this.state.mobileSearch,
        });
    }

    headerVisibility(e) {
        this.setState({headerVisible: e})
    }

    headerHeight(e) {
        this.setState({headerHeight: e})
    }

    dismissCart() {
        const that = this;
        document.querySelector(".cart-popup > .modal-dialog").classList.remove("cart-animation");
        setTimeout(function () {
            that.props.closeShopifyCart();
        }, 400);
    }

    goBack() {
        const {cart} = this.props;
        const checkoutNote = cart.note;
        const subscriptionUpdate = checkoutNote === "updatePaymentDetails";
        const subscriptionPaymentMethodUpdate = checkoutNote === "changePaymentMethod";
        const additionalContribution = checkoutNote === "additional_contribution";
        const {isSubscriptionInCart} = checkSubscriptionStatus(cart);

        if (isTYPage() && (isSubscriptionInCart || subscriptionUpdate || subscriptionPaymentMethodUpdate || additionalContribution)) {
            window.location = `${config.host_rebag}/my-account/wallet/membership`;
        } else if (!isTYPage() && window.history.length > 2) {
            window.history.back();
        } else {
            window.location = `${config.host_rebag}/?cart=open`;
        }
    }

    openLoginModal(type, callback, msg) {
        this.setState({
            login_type: type,
            signup_msg: msg
        }, () => {
            this.handleLoginTypeURLParameterChange(type);
            this.props.renderAuthPopup(type, callback, msg);
            this.props.noScroll(true);
        })
    }

    openLogoutModal() {
        const logout_modal_settings = {
            ...config.logout_default,
            yesAction: this.props.logout,
            noAction: this.props.dismissLogoutPopup
        }
        this.props.noScroll(true);
        this.props.renderLogoutPopup(logout_modal_settings);
    }

    handleLoginType = (loginType) => {
        this.setState({
            login_type: loginType,
            login_type_was_changed: true,
            error_msg: ''
        }, () => {
            const history = this.props.history;
            let urlParams = new URLSearchParams(window.location.search);
            if (window.location.search.indexOf('login-type') > -1) {
                urlParams.delete('login-type')
            }
            history.push({
                search: urlParams.toString()
            })
            this.handleLoginTypeURLParameterChange(loginType);
        })
    }

    handleLoginTypeURLParameterChange(loginType) {
        const history = this.props.history;
        const location = new URL(window.location);
        const search_params = location.search;
        let search;
        if (loginType === 'login' || loginType === 'signup') {
            if (search_params) {
                search = `${location.search}${search_params.search('login-type') === -1  ? '&login-type='+loginType : ''}`;
            } else {
                search = '?login-type='+loginType;
            }
        } else {
            if (location.search) {
                search = location.search;
            } else {
                search = '';
            }
        }
        history.push({
            search: search
        });
    }

    resetLogin = () => {
        const {success_signup} = this.state;
        this.props.signupSuccess(false);
        this.props.socialError(false);
        this.props.noScroll(false);
        let urlParams = new URLSearchParams(window.location.search);
        if (window.location.search.indexOf('NLModalSubscribe=true') > -1) {
            urlParams.delete('NLModalSubscribe')
        }
        if (window.location.search.indexOf('login-type') > -1) {
            urlParams.delete('login-type')
        }
        if (success_signup === true && window.location.pathname === "/sell-now/image-submission") {
            window.location.reload();
        }
        this.props.history.push({
            search: urlParams.toString()
        })
    }

    closeMobileSearch () {
        this.setState({
            mobileSearch: false
        });
        this.props.noScroll(false);
    }

    focusMainContent() {
        document.getElementById("main-content").focus();
    }

    render() {
        const { headerVisible, isCheckoutPage, headerHeight, success_signup, signup_msg, error_msg,
            sidebarOpen, mobileSearch, profile_toggle_status, suppress_newsletter_modal
        } = this.state;
        const {no_scroll} = this.props;
        const image_suffix = window.devicePixelRatio > 1 ? '@2x' : '';
        const {disableSticky, modal_opened, user_logged_in, vault_articles, mobile_small,
            promo_banners, init, isInternational, show_vip_add_to_list_modal, user_profile, mobile_big, cartCount} = this.props;
        const rewards_tiers = init && init.rewards_tiers ? init.rewards_tiers : [];

        if (no_scroll) {
            addNoScroll("no-scroll");
        } else {
            removeNoScroll("no-scroll");
        }

        const top_promo_banner_not_visible = getCookie('top-banner-dismissed');

        let my_profile = '';
        let current_tier = null;
        const activeMembership = user_profile && isRPlusMembershipActive(user_profile);
        if(user_profile){
            current_tier = rewards_tiers[user_profile.tier.tier_key];
            my_profile = <div className="rr-holder">
                <div className="header-top-nav__rr-details">
                    {activeMembership &&
                        <RewardsPlusLogo
                            style={{ width: 20, marginRight: 5 }}
                            label="Rebag+ Membership"
                        />
                    }
                    <span className="header-top-nav__rr-name">{user_profile.first_name ? user_profile.first_name + ':' : <ProfileIcon style={{width: 15, marginBottom: 2, marginRight: 1}} className="dropdown-item-icon" label="My Profile"/>} </span>
                    <span className="header-top-nav__rr-text">
                        {isInternational && 'USD'} <Currency value={user_profile.wallet_total}/> Wallet Balance
                    </span>
                    <ArrowDownRounded
                        style={{width: 15, marginTop: 3, marginLeft: 8}}
                        className={`header-top-nav__profile-arrow ${!profile_toggle_status ? "" : "header-top-nav__profile-arrow--up"}`}
                        label="Profile"
                        stroke="#000000"
                        strokeWidth="1"
                    />
                </div>
            </div>;
        }

        const can_see_first_look_items = user_profile ? canSeeFirstLook(user_profile) : false;

        return !isCheckoutPage ?
            <>
                {show_vip_add_to_list_modal &&
                    <VipModal />
                }
                <ConfirmEmail />
                <SaveSearchModal />
                <FinishSignupModal/>
                <a
                    href="#main-content"
                    className="skip-to-content"
                    onClick={this.focusMainContent}
                >
                    Skip to content
                </a>
                <InProductMKTPopup />
                {modal_opened &&
                <LoginModal
                    handleLoginType={this.handleLoginType}
                    resetLogin={this.resetLogin}
                    signup_msg={signup_msg}
                    error_msg={error_msg}
                />
                }
                {success_signup && !suppress_newsletter_modal &&
                <OfferCodeThankYouModal
                    mobile_small={mobile_small}
                    dismissModal={this.resetLogin}
                    redirect_on_dismiss={false}
                />
                }
                {mobile_big &&
                <SidebarMenu
                    user={user_logged_in}
                    sidebarOpen={sidebarOpen}
                    onSetSidebarOpen={this.onSetSidebarOpen}
                    openLoginModal={this.openLoginModal}
                    openLogoutModal={this.openLogoutModal}
                    vault_articles={vault_articles}
                    user_profile={user_profile}
                    current_tier={current_tier}
                />
                }
                <Headroom
                    id="headroom"
                    onUnpin={() => this.headerVisibility(false)}
                    onPin={() => this.headerVisibility(true)}
                    onUnfix={() => this.headerVisibility(true)}
                    style={headerHeight ? {'height': headerHeight} : {}}
                    disable={disableSticky}
                >
                    <div className="top-carousel-promo">
                    {!top_promo_banner_not_visible && promo_banners &&
                        <TopCarouselPromo
                            alerts={promo_banners}
                            mobile={mobile_big}
                            headerHeight={this.headerHeight.bind(this)}
                        />
                    }
                    </div>
                    <div className="header-top-nav">
                        <Container>
                            <Navbar
                                as="div"
                                className="header-top-nav__navbar"
                                role=""
                            >
                                <div className="header-top-nav__navbar--left">
                                    {mobile_big && !mobileSearch &&
                                    <div className="sidebar-menu-nav__open-menu-container">
                                        <Button
                                            className="sidebar-menu-nav__open-menu"
                                            onClick={() => this.onSetSidebarOpen(true)}
                                            variant="clean"
                                            aria-label="Open Menu"
                                            ref={this.burgerButtonRef}
                                            tabIndex={`${sidebarOpen ? "-1" : "0"}`}
                                        >
                                            <span className="icon-burger-menu"/>
                                        </Button>
                                    </div>
                                    }
                                    {mobile_big && mobileSearch &&
                                    <Button
                                        className="header-top-nav__back"
                                        onClick={() => this.closeMobileSearch()}
                                        variant="clean"
                                        aria-label="Back"
                                    >
                                        <span className="icon-chevron-left"/>
                                    </Button>
                                    }
                                    <NavbarBrand
                                        className="header-top-nav__logo"
                                        href={config.host_rebag}
                                    >
                                        <Image
                                            src={`${config.MEDIA_URL}/img/rebag-logo-black${image_suffix}.png`}
                                            alt="Rebag.com"
                                        />
                                    </NavbarBrand>
                                    {!mobile_big && !isCheckoutPage &&
                                    <SearchBar
                                        mobile={mobile_big}
                                        top_promo_banner_not_visible={top_promo_banner_not_visible}
                                    />
                                    }
                                </div>
                                <div
                                    id="headerTopNav"
                                    className="header-top-nav__details"
                                >
                                    <Nav className="ml-auto">
                                        {!mobile_big && !user_logged_in &&
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--text"
                                            onClick={() => this.openLoginModal('login')}
                                            as="button"
                                        >
                                            Log in
                                        </Nav.Item>
                                        }
                                        {!mobile_big && !user_logged_in &&
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--text"
                                            onClick={() => this.openLoginModal('signup')}
                                            as="button"
                                        >
                                            Sign Up
                                        </Nav.Item>
                                        }
                                        {mobile_big && !isCheckoutPage &&
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--icon"
                                            onClick={() => this.toggleMobileSearch()}
                                            as="button"
                                            aria-label="Search"
                                            id='mobile-search-button'
                                        >
                                            <SearchIconThin
                                                style={{width: 21}}
                                                color="#000000"
                                                label="Search"
                                                id="mobile-search-icon"
                                            />
                                        </Nav.Item>
                                        }
                                        {!mobile_big && user_logged_in && headerVisible && user_profile &&
                                        <NavDropdown
                                            alignRight
                                            title={my_profile}
                                            className="header-top-nav__nav-item header-top-nav__nav-item--text"
                                            onToggle={(e) => this.toggleProfile(e)}
                                        >
                                            <NavDropdown.Item
                                                href={`${config.host_rebag}/my-account/wallet`}
                                                aria-label="My Rebag Wallet"
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <WalletIcon
                                                    style={{width: 18}}
                                                    className="dropdown-item-icon"
                                                    label="Rebag Wallet"
                                                />
                                                <span className="header-top-nav__rr-profile-container">
                                                    <span className="header-top-nav__rr-profile-item">
                                                        <span className="header-top-nav__rr-text">Wallet</span>
                                                    </span>
                                                    <span className="header-top-nav__rr-profile-item">
                                                        <span className="header-top-nav__rr-text">
                                                            <Currency value={user_profile.wallet_total} className="font-weight-bold" /> <span className="header-top-nav__rr-text">total balance</span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                href={activeMembership ? `${config.host_rebag}/my-account/wallet/membership` : `${config.host_rebag}/membership`}
                                                aria-label="My Orders"
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <RewardsPlusLogo
                                                    style={{width: 20, marginLeft: -3}}
                                                    className="dropdown-item-icon"
                                                    label="Rebag+ Summary"
                                                />
                                                <span className="header-top-nav__rr-profile-container">
                                                    <span className="header-top-nav__rr-profile-item">
                                                        {activeMembership ?
                                                            <span className="header-top-nav__rr-text">Rebag<sup>+</sup></span>
                                                            :
                                                            <span className="header-top-nav__rr-text">Join Rebag<sup>+</sup> Membership</span>
                                                        }
                                                    </span>
                                                    {activeMembership && user_profile.rewards_credit > 0 &&
                                                    <span className="header-top-nav__rr-profile-item">
                                                        <span className="header-top-nav__rr-text">
                                                            <Currency value={user_profile.rewards_credit} className="font-weight-bold"/> <span className="header-top-nav__rr-text">Credits</span>
                                                        </span>
                                                    </span>
                                                    }
                                                </span>
                                            </NavDropdown.Item>
                                            <NavDropdown.Divider/>
                                            <NavDropdown.Item
                                                href={`${config.host_rebag}/my-account/purchases`}
                                                aria-label="My Orders"
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <BoxIcon
                                                    style={{width: 18}}
                                                    className="dropdown-item-icon"
                                                    label="Orders"
                                                />
                                                Orders
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                aria-label="My Submissions"
                                                href={`${config.host_rebag}/my-account/submissions`}
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <ChecklistIcon
                                                    style={{width: 14, marginLeft: 2}}
                                                    className="dropdown-item-icon"
                                                    label="Submissions"
                                                />
                                                Submissions
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                aria-label="My Consignments"
                                                href={`${config.host_rebag}/my-account/consignments`}
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <LabelIcon
                                                    style={{width: 18, marginLeft: 2}}
                                                    className="dropdown-item-icon"
                                                    label="Consignments"
                                                />
                                                Consignments
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                aria-label="My Clair Bookmarks"
                                                href={`${config.host_rebag}/my-account/clair-codes`}
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <BarcodeIcon
                                                    style={{width: 17}}
                                                    className="dropdown-item-icon"
                                                    label="Followed Clair Codes"
                                                />
                                                Followed Clair Codes
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                aria-label="My Account"
                                                href={`${config.host_rebag}/my-account/profile`}
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <ProfileIcon
                                                    style={{width: 14, marginLeft: 1}}
                                                    className="dropdown-item-icon"
                                                    label="Profile"
                                                />
                                                Profile
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                onClick={this.openLogoutModal}
                                                aria-label="Log Out"
                                                className="header-top-nav__nav-item header-top-nav__nav-item--item"
                                            >
                                                <LogOutIcon
                                                    style={{width: 14, marginLeft: 1}}
                                                    className="dropdown-item-icon"
                                                    label="Log Out"
                                                />
                                                Log Out
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                        }
                                        {user_logged_in &&
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--icon"
                                            as="a"
                                            href={`${config.host_rebag}/my-account/favorites`}
                                            aria-label="My Favorites"
                                        >
                                            <HeartIcon
                                                style={{width: 21}}
                                                className="dropdown-item-icon"
                                                label="Favorite"
                                            />
                                        </Nav.Item>
                                        }
                                        {user_logged_in &&
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--icon"
                                            as="a"
                                            href={`${config.host_rebag}/my-account/saved-searches`}
                                            aria-label="My Saved Searches"
                                        >
                                            <BookmarkIcon
                                                style={{width: 14,paddingTop: 1}}
                                                className="dropdown-item-icon"
                                                label="My Saved Searches"
                                            />
                                        </Nav.Item>
                                        }
                                        <Nav.Item
                                            className="header-top-nav__nav-item header-top-nav__nav-item--icon"
                                            aria-label="Cart"
                                            as="button"
                                            onClick={() => this.props.openShopifyCart(false)}
                                        >
                                            <CartIcon
                                                style={{width: 21}}
                                                className="dropdown-item-icon"
                                                label="Cart"
                                            />
                                            <sup
                                                className={`header-top-nav__nav-item-counter ${cartCount > 0 ? '' : 'header-top-nav__nav-item-counter--invisible'}`}
                                            >
                                                {cartCount}
                                            </sup>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </Navbar>
                        </Container>
                    </div>
                    {!mobile_big && <div className="header-menu-nav">
                        <Container>
                            <Navbar as="div" className="header-menu-nav__navbar">
                                <div
                                    id="headerMenuNav"
                                    className="header-menu-nav__details"
                                >
                                    <Nav className="header-menu-nav__menu-left mr-auto">
                                        {config.header_menu_items.filter((header_menu_item) => filterForYouMenuItemForNoLoggedInUser(header_menu_item)).map((header_menu_item, index) => {
                                            if (header_menu_item.show_desktop) {
                                                if (header_menu_item.key === "vip-preview") {
                                                    if (can_see_first_look_items) {
                                                        return (
                                                            <Nav.Item
                                                                className="header-menu-nav__menu-item nav-link header-menu-nav__menu-item--hide-1300"
                                                                key={index}
                                                            >
                                                                <FirstLookNav
                                                                    can_see_first_look_items={can_see_first_look_items}
                                                                    className="header-menu-nav__menu-button"
                                                                />
                                                            </Nav.Item>
                                                        )
                                                    }
                                                    return null;
                                                }
                                                return (
                                                    <HeaderMenuItem
                                                        key={header_menu_item.key}
                                                        menu_item={header_menu_item}
                                                        showHideMenus={this.showHideMenus}
                                                        mobile={mobile_big}
                                                        vault_articles={vault_articles}
                                                    />
                                                )
                                            }
                                        })}
                                    </Nav>
                                    <Nav className="header-menu-nav__menu-right justify-content-end">
                                        <Nav.Item
                                            className="header-menu-nav__menu-item nav-link"
                                            as="a"
                                            href={`${config.host_rebag}/trade/`}
                                        >
                                            Trade
                                        </Nav.Item>
                                        <Nav.Item
                                            className="header-menu-nav__menu-item header-menu-nav__menu-item--cta nav-link"
                                            as="a"
                                            href={`${config.host_rebag}/sell-now/`}
                                        >
                                            Sell
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </Navbar>
                        </Container>
                    </div>
                    }
                    {mobile_big && mobileSearch && !isCheckoutPage &&
                      <SearchBar
                        closeMobileSearch={() => this.closeMobileSearch()}
                        mobile={mobile_big}
                        top_promo_banner_not_visible={top_promo_banner_not_visible}
                      />
                    }
                    {mobile_big &&
                    <Nav
                        className="header-menu-nav__menu-left mr-auto"
                    >
                        {config.header_menu_items.filter((header_menu_item) => filterForYouMenuItemForNoLoggedInUser(header_menu_item)).map((header_menu_item) => {
                            if (header_menu_item.key === "vip-preview") {
                                if (can_see_first_look_items) {
                                    return (
                                        <Nav.Item
                                            className="header-menu-nav__menu-item nav-link"
                                        >
                                            <FirstLookNav
                                                can_see_first_look_items={can_see_first_look_items}
                                                className="header-menu-nav__menu-button"
                                            />
                                        </Nav.Item>
                                    )
                                }
                                return null;
                            }
                            return (
                                <HeaderMenuItem
                                    key={header_menu_item.key}
                                    menu_item={header_menu_item}
                                    showHideMenus={this.showHideMenus}
                                    mobile={mobile_big}
                                    vault_articles={vault_articles}
                                />
                            )
                        })}
                    </Nav>
                    }
                </Headroom>
            </>
            :
            <div className="rebag-checkout__header-container">
                {modal_opened &&
                <LoginModal
                    handleLoginType={this.handleLoginType}
                    resetLogin={this.resetLogin}
                    signup_msg={signup_msg}
                    error_msg={error_msg}
                />
                }
                <HeaderSimplified
                    action={this.goBack}
                />
            </div>
    }
}

const mapStateToProps = function (state) {
    const {checkout, cart, cartCount} = state.shopifyReducer;
    const {
        user_logged_in, vault_articles, mobile_small, promo_banners, no_scroll,
        init, mobile_big, isInternational, show_vip_add_to_list_modal,
    } = state.appReducer;
    const {user_profile} = state.myAccountReducer;
    const {login_type, modal_opened, signup_msg, success_signup, suppress_newsletter_modal} = state.appReducer.auth;

    return { modal_opened, user_logged_in, vault_articles, mobile_small, promo_banners,
        init, isInternational, show_vip_add_to_list_modal, user_profile, signup_msg, success_signup,
        suppress_newsletter_modal, login_type, mobile_big, no_scroll, checkout, cart, cartCount
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getPromoBanners,
        renderAuthPopup,
        closeLoginModal,
        userLoggedIn,
        userLoggedOut,
        getVaultItems,
        openShopifyCart,
        closeShopifyCart,
        showModalSpinner,
        hideModalSpinner,
        signupSuccess,
        getRecentlyViewed,
        getForYouHomepageData,
        socialError,
        logout,
        renderLogoutPopup,
        dismissLogoutPopup,
        setSavedSearchesModal,
        getSavedSearches,
        showVipModal,
        noScroll,
    }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
